import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DeleteModalComponent } from 'src/app/common-components/delete-modal/delete-modal.component';
import { Permission } from 'src/app/models/permission';
import { InAPPCrudComponent } from '../crud/crud.component';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class InAPPListComponent implements OnInit {

  constructor(private dialog: MatDialog) { }

  
	userPermissions: any = [];

  dataSource=[
    {id:1,name:'kyc',number:0},
    {id:1,name:'kyc',number:0},
    {id:1,name:'kyc',number:0},
    {id:1,name:'kyc',number:0},
    {id:1,name:'kyc',number:0},
    {id:1,name:'kyc',number:0},
    {id:1,name:'kyc',number:0},
    {id:1,name:'kyc',number:0},
    {id:1,name:'kyc',number:0},
    {id:1,name:'kyc',number:0},
    {id:1,name:'kyc',number:0},
    {id:1,name:'kyc',number:0},
  ]
  
  displayedColumns: string[] = ['Perticular', 'Score', 'no','yes_img','title',  'action'];

  ngOnInit(): void {
  }

  
	checkPermission(toCheckPermission: string): boolean {
		for (var permission of this.userPermissions) {
			if (toCheckPermission == permission.permission_name) {
				return true;
			}
		}
		return false;
	}


  ///////////////////////////////////////////
	/////delete opration
	//////////////////////////////////////////
	deleteRecord(id) {


		//open dialog box
		let dialogData = this.dialog.open(DeleteModalComponent, {
			data: { id }
		});

		dialogData.afterClosed().subscribe(res => {

			if (res) {
		
			}

		});

	}
  ///////////////////////////////////////////
	/////delete opration
	//////////////////////////////////////////
	InAppAdd(id) {


		//open dialog box
		let dialogData = this.dialog.open(InAPPCrudComponent, {
			data: { id }
		});

		dialogData.afterClosed().subscribe(res => {

			if (res) {
		
			}

		});

	}



}


